import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiRequest, setUserDetails, destroyUserDetails} from "services/apiRequest";
import { requestType } from "services/requests";

export const loginUser = createAsyncThunk(
    'user/loginUser',
    async(loginPayloads, thunkAPI) => {
        try{
            const request = await apiRequest({
                requestType: requestType.authUser,
                payload: {
                    data: loginPayloads
                },
            })
            
            const response = await request?.data;

            if (response?.status === 0) {
                setUserDetails(response.data);
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(request.data);
            }
        }    
        catch (e) {
            return thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const updateDataUser = createAsyncThunk(
    'user/updateDataUser',
    async(userUidPayloads, thunkAPI) => {
        try{
            const request = await apiRequest({
                requestType: requestType.getUserDetails,
                payload: {
                    data: userUidPayloads
                },
            })
            
            const response = await request?.data;

            if (response?.status === 0) {
                // setUserDetails(response.data);
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(request.data);
            }
        }    
        catch (e) {
            return thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const logoutUser = createAsyncThunk(
    'user/logoutUser',
    async(logoutPayloads, thunkAPI) => {
        try{
            const request = await apiRequest({
                requestType: requestType.logoutUser,
                payload: {
                    data: logoutPayloads
                },
            })
            
            const response = await request?.data;
            if (response?.status === 0) {
                destroyUserDetails();
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(request.data);
            }
        }    
        catch (e) {
            return thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const deleteUser = createAsyncThunk(
    'user/deleteUser',
    async(deletePayloads, thunkAPI) => {
        try{
            const request = await apiRequest({
                requestType: requestType.deleteAccount,
                payload: {
                    data: deletePayloads
                },
            })
            
            const response = await request?.data;
            if (response?.status === 0) {
                destroyUserDetails();
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(request.data);
            }
        }    
        catch (e) {
            return thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

const initialState = {
  loading: false,
  userInfo: {},
  userToken: null, 
  error: null,
  success: false,
}

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {},
    extraReducers:(builder) => {
        builder
        // reducer case on login action
        .addCase(loginUser.pending, (state) => {
            state.loading = true;
            state.userInfo = null;
            state.userToken = null;
            state.error = null;
            state.success = false;
        })
        .addCase(loginUser.fulfilled, (state, action) => {
            state.loading = false;
            state.userInfo = action.payload ? action.payload.user_details : null;
            state.userToken = action.payload ? action.payload.user_session : null;
            state.error = null;
            state.success = true;
        })
        .addCase(loginUser.rejected, (state, action) => {
            state.loading = false;
            state.userInfo = null;
            state.userToken = null;
            if(action.error.message === 'Request failed with status code 401') {
                state.error = "Access Denied!, Invalid Credentials";
            } else {
                state.error = action.error.message;
            }
            state.success = false;
        })

        // reducer case on update profile action
        .addCase(updateDataUser.fulfilled, (state, action) => {
            state.loading = false;
            state.userInfo = action.payload ? action.payload : null;
            // state.userToken = action.payload ? action.payload.user_session : null;
            state.error = null;
            state.success = true;
        })
        .addCase(updateDataUser.rejected, (state, action) => {
            state.loading = false;
            state.userInfo = null;
            // state.userToken = null;
            if(action.error.message === 'Request failed with status code 401') {
                state.error = "Access Denied!, Invalid Credentials";
            } else {
                state.error = action.error.message;
            }
            state.success = false;
        })

        // reducer case on logout action
        .addCase(logoutUser.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.success = false;
        })
        .addCase(logoutUser.fulfilled, (state) => {
            state.loading = false;
            state.userInfo = null;
            state.userToken = null;
            state.error = null;
            state.success = true;
        })
        .addCase(logoutUser.rejected, (state, action) => {
            state.loading = false;
            if(action.error.message === 'Request failed with status code 401') {
                state.error = "Access Denied!, Invalid Credentials";
            } else {
                state.error = action.error.message;
            }
            state.success = false;
        })

        // reducer case on delete user action
        .addCase(deleteUser.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.success = false;
        })
        .addCase(deleteUser.fulfilled, (state) => {
            state.loading = false;
            state.userInfo = null;
            state.userToken = null;
            state.error = null;
            state.success = true;
        })
        .addCase(deleteUser.rejected, (state, action) => {
            state.loading = false;
            if(action.error.message === 'Request failed with status code 401') {
                state.error = "Access Denied!, Invalid Credentials";
            } else {
                state.error = action.error.message;
            }
            state.success = false;
        })
    },
  })

export default authSlice.reducer
